import AdminEventsPageComponent from "./components/AdminEventsPageComponent";

import axios from "axios";

const fetchEvents = async (abctrl) => {
    const { data } = await axios.get("/api/events/admin", {
        signal: abctrl.signal,
    })
    console.log('[fetchEvents] data =',data)
    return data;
}

const deleteEvent = async (eventId) => {
    const { data } = await axios.delete(`/api/events/admin/${eventId}`);
    return data
}

const AdminEventsPage = () => {
  return <AdminEventsPageComponent fetchEvents={fetchEvents} deleteEvent={deleteEvent} />
};

export default AdminEventsPage;
